import { render, staticRenderFns } from "./Redimentos.vue?vue&type=template&id=4ae49917"
import script from "./Redimentos.vue?vue&type=script&lang=js"
export * from "./Redimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports